<template>
        <div >
      
                            <h1>優惠券</h1>
                            <section class="member_coupon">
                                <div class="tabs">
                                    <ul class="tabsNav cf">
                                        <li>
                                            <a  href="#tab1">已取得<i>{{this.allCouponDatas.length}}</i></a>
                                        </li>
                                        <li>
                                            <a  href="#tab2">可贈送<i>0</i></a>
                                        </li>
                                    </ul>

                                    <div class="content">
                                        <div  class="tab1"  id="tab1">
                                            <div class="hdr">
                                                <!-- <label for="addcoupon" class="inp error"> -->
                                                <label v-if="this.$store.state.couponState == ''" for="addcoupon" class="inp ">

                                                    <input v-model="inputCouponValue" type="text" placeholder=" " id="addcoupon">
                                                    <span class="label">存入優惠券，請輸入序號</span>
                                                    <span class="border"></span>
                                                    <span class="errorText">{{this.$store.state.couponState}}</span>
                                                </label>

                                                <label v-else for="addcoupon" class="inp error">
                                                    <input v-model="inputCouponValue" type="text" placeholder=" " id="addcoupon">
                                                    <span class="label">存入優惠券，請輸入序號</span>
                                                    <span class="border"></span>
                                                    <span class="errorText">{{this.$store.state.couponState}}</span>
                                                </label> 
                                                <button @click="inputCoupon()"  type="submit" class="btnStyle_2" id="submit_addcoupon">
                                                    <span data-original-title="確定存入">確定存入</span>
                                                </button>
                                                <div class="toast">
                                                    <div class="wrap">成功取得優惠券</div>
                                                </div>
                                            </div>
                                            <section class="conditionSection cf">
                                                <div class="col-l">共<i>{{this.allCouponDatas.length}}</i>張</div>
                                            </section>
                                             <ul class="cf">
                                               
                                                <li class="coupon_item"  v-for = "couponData in couponDatas">
                                                    <div class="hd">
                                                        <!-- <h2>*所有課程皆可兌換</h2> -->
                                                        <h2 v-if="couponData.channel == null">*所有課程皆可兌換</h2>
                                                         <h2 v-else>可兌換：{{couponData.channel.title}}</h2>
                                                       

                                                        <b v-if="couponData.coupon_extension == null">{{new Date(couponData.coupon_start).toLocaleDateString()}} - {{new Date(couponData.coupon_end).toLocaleDateString()}}</b>
                                                        <b  class="deletedate" v-else>{{new Date(couponData.coupon_start).toLocaleDateString()}} - {{new Date(couponData.coupon_end).toLocaleDateString()}}</b>
                                                        <b v-if="couponData.coupon_extension != null" class="newdate">{{new Date(couponData.coupon_start).toLocaleDateString()}} - {{new Date(couponData.coupon_extension).toLocaleDateString()}}</b>
                                                        <div class="info compaign">
                                                            <i>活動</i>
                                                            <strong>{{couponData.title}}</strong>
                                                        </div>
                                                        <div class="info saved">
                                                            <i>存入</i>
                                                            <strong>{{new Date(couponData.enter_date).toLocaleDateString()}}</strong>
                                                        </div>
                                                    </div>
                                                    <div class="ft cf">
                                                        <div class="points">
                                                            <i>可折抵</i>
                                                            <strong>{{couponData.points}}點</strong>
                                                        </div>
                                                          
                                                            <!-- <div class="directLink"><b>檢視課程</b></div> -->

                                                    </div>
                                                    <!-- <router-link to="/channel/list"><a class="fullLink" href=""/></router-link> -->
                                                </li>
                                             </ul>
                                             <h3 class="title_line"><span>已使用</span></h3>
                                              <ul class="cf">
                                               <li class="coupon_item used"  v-for = "couponData in useCouponDatas">

                                                    <div class="hd">
                                                         <h2 v-if="couponData.channel == null">*所有課程皆可兌換</h2>
                                                         <h2 v-else>可兌換：{{couponData.channel.title}}</h2>
                                                        <b>{{new Date(couponData.coupon_start).toLocaleDateString()}} - {{new Date(couponData.coupon_end).toLocaleDateString()}}</b>
                                                        <div class="info compaign">
                                                            <i>活動</i>
                                                            <strong>{{couponData.title}}</strong>
                                                        </div>
                                                        <div class="info saved">
                                                            <i>存入</i>
                                                            <strong>{{new Date(couponData.enter_date).toLocaleDateString()}}</strong>
                                                        </div>
                                                    </div>
                                                    <div class="ft cf">
                                                        <div class="points">
                                                            <i>可折抵</i>
                                                          <strong>{{couponData.points}}點</strong>
                                                        </div>
                                                        <div class="status">{{new Date(couponData.point_consume.created_at).toLocaleDateString()}} 已使用</div>
                                                    </div>
                                                </li>
                                            </ul>

                                            <h3 class="title_line"><span>已過期</span></h3>

                                               <ul class="cf">
                                               <li class="coupon_item used expired"  v-for = "couponData in expiredCouponDatas">

                                                    <div class="hd">
                                                         <h2 v-if="couponData.channel == null">*所有課程皆可兌換</h2>
                                                         <h2 v-else>可兌換：{{couponData.channel.title}}</h2>
                                                        <b>{{new Date(couponData.coupon_start).toLocaleDateString()}} - {{new Date(couponData.coupon_end).toLocaleDateString()}}</b>
                                                        <div class="info compaign">
                                                            <i>活動</i>
                                                            <strong>{{couponData.title}}</strong>
                                                        </div>
                                                        <div class="info saved">
                                                            <i>存入</i>
                                                            <strong>{{new Date(couponData.enter_date).toLocaleDateString()}}</strong>
                                                        </div>
                                                    </div>
                                                    <div class="ft cf">
                                                        <div class="points">
                                                            <i>可折抵</i>
                                                          <strong>{{couponData.points}}點</strong>
                                                        </div>
                                                        <div class="status">已過期</div>

                                                        <!-- <div class="status">{{new Date(couponData.point_consume.created_at).toLocaleDateString()}} 已使用</div> -->
                                                    </div>
                                                </li>
                                            </ul>
                                            <!-- <ul class="cf">
                                                <li class="coupon_item">
                                                    <div class="hd">
                                                        <h2>*所有課程皆可兌換</h2>
                                                        <b>2019/06/29 - 2019/08/29</b>
                                                        <div class="info compaign">
                                                            <i>活動</i>
                                                            <strong>有意思生活節</strong>
                                                        </div>
                                                        <div class="info saved">
                                                            <i>存入</i>
                                                            <strong>2018/05/10</strong>
                                                        </div>
                                                    </div>
                                                    <div class="ft cf">
                                                        <div class="points">
                                                            <i>可折抵</i>
                                                            <strong>20點</strong>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li class="coupon_item">
                                                    <div class="hd">
                                                        <h2>可兌換：紅樓夢非關愛情-大觀園的成長紅樓夢非關愛情-大觀園的成長</h2>
                                                        <b class="deletedate">2019/06/29 - 2019/08/29</b>
                                                        <b class="newdate">2019/06/29 - 2019/08/29</b>
                                                        <div class="info compaign">
                                                            <i>活動</i>
                                                            <strong>有意思生活節</strong>
                                                        </div>
                                                        <div class="info saved">
                                                            <i>存入</i>
                                                            <strong>2018/05/10</strong>
                                                        </div>
                                                        <div class="info gifted">
                                                            <i>贈送人</i>
                                                            <strong>小華</strong>
                                                        </div>
                                                    </div>
                                                    <div class="ft cf">
                                                        <div class="points">
                                                            <i>可折抵</i>
                                                            <strong>150點</strong>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul> -->

                                            <!-- <h3 class="title_line"><span>已使用</span></h3>
                                            <ul class="cf">
                                                <li class="coupon_item used">
                                                    <div class="hd">
                                                        <h2>*所有課程皆可兌換</h2>
                                                        <b>2019/06/29 - 2019/08/29</b>
                                                        <div class="info compaign">
                                                            <i>活動</i>
                                                            <strong>有意思生活節</strong>
                                                        </div>
                                                        <div class="info saved">
                                                            <i>存入</i>
                                                            <strong>2018/05/10</strong>
                                                        </div>
                                                    </div>
                                                    <div class="ft cf">
                                                        <div class="points">
                                                            <i>可折抵</i>
                                                            <strong>20點</strong>
                                                        </div>
                                                        <div class="status">2018/08/22 已使用</div>
                                                    </div>
                                                </li>
                                            </ul>

                                            <h3 class="title_line"><span>已過期</span></h3>
                                            <ul class="cf">
                                                <li class="coupon_item used">
                                                    <div class="hd">
                                                        <h2>*所有課程皆可兌換</h2>
                                                        <b>2019/06/29 - 2019/08/29</b>
                                                        <div class="info compaign">
                                                            <i>活動</i>
                                                            <strong>有意思生活節</strong>
                                                        </div>
                                                        <div class="info saved">
                                                            <i>存入</i>
                                                            <strong>2018/05/10</strong>
                                                        </div>
                                                    </div>
                                                    <div class="ft cf">
                                                        <div class="points">
                                                            <i>可折抵</i>
                                                            <strong>20點</strong>
                                                        </div>
                                                        <div class="status">已過期</div>
                                                    </div>
                                                </li>
                                            </ul> -->

                                        </div>
                                        <div class="tab2"  id="tab2">
                                            <div class="empty">
                                                <figure>
                                                    <img src="@/assets/images/status_coupon_coming.png" alt="優惠券">
                                                    <figcaption>即將推出 敬請期待</figcaption>
                                                </figure>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                            </section>                
              
            </div>
            
            

            

            <!--我的帳戶結束-->


</template>

<script>
import * as firebase from "firebase";
import { mapGetters } from "vuex";
import { getCoupon } from "@/assets/js/api/api.js";

export default {
       name: 'async',
    metaInfo () {
      return {
        
        title: '優惠券 | 我的 | 一刻鯨選',
        meta: [
            // OpenGraph data (Most widely used)
            {property: 'og:title', content: '優惠券 | 我的 | 一刻鯨選'},
            {property: 'og:site_name', content: '優惠券 | 我的 | 一刻鯨選'},
            // The list of types is available here: http://ogp.me/#types
            {property: 'og:type', content: 'website'},
            // Should the the same as your canonical link, see below.
            {property: 'og:url', content: window.location.toString()},
            {property: 'og:image', content: this.$store.state.urlDomain+'/static/logo.jpg'},
            // Often the same as your meta description, but not always.
            {property: 'og:description', content: '登入後，即可查看帳戶所有資訊。'},
        
        ]
      }
    },
     data() {
        return {
            allCouponDatas: [],
            couponDatas: [],
            expiredCouponDatas: [],//過期
            noExpiredCouponDatas: [],//沒過期
            useCouponDatas: [],//使用過
            newCouponDatas: [],
            inputCouponValue:'',
            isCoupon:false,
        }
     },
  computed: {
    ...mapGetters(["userInfo,credentialToken"])
    
  },
  methods:{
      convertUTCTimeToLocalTime: function (UTCDateString) {
        if(!UTCDateString){
          return '-';
        }
        function formatFunc(str) {    //格式化显示
          return str > 9 ? str : '0' + str
        }
        var date2 = new Date(UTCDateString);     //这步是关键
        var year = date2.getFullYear();
        var mon = formatFunc(date2.getMonth() + 1);
        var day = formatFunc(date2.getDate());
        var hour = date2.getHours();
     //   var noon = hour >= 12 ? 'PM' : 'AM';
       // hour = hour>=12?hour-12:hour;
       // hour = formatFunc(hour);
        var min = formatFunc(date2.getMinutes());
        var dateStr = year+'-'+mon+'-'+day+' '+hour+':'+min;
        return dateStr;
      },
      signOut() {
      firebase
        .auth()
        .signOut()
        .then(() => {
           this.$store.dispatch("authLogout").then(() => {
            this.$router.push("/");
            this.$store.commit('savePath', '/index')

          });
            localStorage.removeItem('user-info') 

        })
        .catch(function(error) {
          console.log(error);
        });
    },
    inputCoupon(){
        this.$store.commit('couponState', "")
           this.axios.patch(
               this.$store.getters.baseURL + 'coupons/'+this.inputCouponValue,
               {'number':this.inputCouponValue},
               { headers: {"Authorization" : `Bearer ${localStorage.getItem('credentialToken')}`} }
               ).then(response => {
                    if(response.data != null){
                        this.$store.commit('couponState', "")
                                $(".toast").slideDown();
                                window.setTimeout(function() {
                                    $(".toast").slideUp();
                                     location. reload()
                                }, 2500);
                      
                            }
                    })
                    .catch(error => console.log("log:"+error));
                }
            },
        mounted(){
      

      
                    // //Tabs functionality
                    //Firstly hide all content divs
                   // $('.content > div').hide();
                    //Then show the first content div
                   // $('.content > div:first').show();
                    //Add active class to the first tab link
                    $('.tabsNav li:first').addClass('active');
                    //Functionality when a tab is clicked

                    $('.tabsNav li a').click(function(){
                        //Firstly remove the current active class
                        $('.tabsNav li').removeClass('active');
                        //Apply active class to the parent(li) of the link tag
                        $(this).parent().addClass('active');
                        //Set currentTab to this link
                        var currentTab = $(this).attr('href');
                        //Hide away all tabs
                         $(".tab1").hide();
                         $(".tab2").hide();

                        //show the current tab
                         $(currentTab).show();
                        //Stop default link action from happening
                         return false;
                    }); 
                     $(".toast").hide();
                //       //toast
                //     var toast = $(".toast");

                //     toast.hide();

                //  $("#submit_addcoupon").click(function(e) {

                //       // if(this.isCoupon){
                //             e.preventDefault();
                //              $(".toast").slideDown();
                //             window.setTimeout(function() {
                //                  $(".toast").slideUp();
                //             }, 2500);
                //       // }
                //     });
                  

               
                    
  },

  created() {
    this.axios
       .get(this.$store.getters.baseURL + 'coupons', { headers: {"Authorization" : `Bearer ${localStorage.getItem('credentialToken')}`} })
      .then(response => {
          this.allCouponDatas = response.data
          var i;
          for( i =0; i < this.allCouponDatas.length; i++ ){
            if(Date.parse(new Date().toLocaleDateString()).valueOf() > Date.parse(new Date(this.convertUTCTimeToLocalTime(this.allCouponDatas[i].coupon_end)).toLocaleDateString()).valueOf()
                && this.allCouponDatas[i].coupon_extension == null) {
                 this.expiredCouponDatas.push(this.allCouponDatas[i]);
           }else{
              this.noExpiredCouponDatas.push(this.allCouponDatas[i]);
           }

          }

             i = 0;
          for( i =0; i < this.noExpiredCouponDatas.length; i++ ){
            if( this.noExpiredCouponDatas[i].point_consume != null) {
               this.useCouponDatas.push(this.noExpiredCouponDatas[i]);
           }else{
              this.couponDatas.push(this.noExpiredCouponDatas[i]);

           }

          }
         
         

      })
      .catch(error => console.log("log:"+error));
  },
};
</script>

<style>

@import '../../../assets/css/user.css';
@import '../../../assets/css/user_rwd.css';
 body {padding-top: 0;}
 /* body {padding-top: 0;}
 .bodyHeader {display: none;} */
</style>



// WEBPACK FOOTER //
// src/components/views/mySubviews/MyCoupon.vue